import React, {PropTypes} from 'react';
import {LibraryMaterialCard} from './index';

export default function LibraryMaterialList({materials, onDocumentDownload}) {
  return (
    <div className="library-material-list">
      {materials.map(material => <LibraryMaterialCard key={material.id} material={material} onDocumentDownload={onDocumentDownload} />)}
    </div>
  );
}

LibraryMaterialList.propTypes = {
  materials: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDocumentDownload: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/library/components/LibraryMaterialList.js